{{#if (and multiTermNewExpression (or previous next))}}({{ newExpression }}){{else}}{{ newExpression }}{{/if}}{{#with next}} * {{> (partial "snippets/num-threads-running")}}{{/with~}}
